import React, { useMemo, useState } from 'react';
import { Box, Avatar, Typography, IconButton } from "@mui/material"
import { t } from "@lingui/macro"
import { getFixedImageUrl } from "../api"
import { TComponentCategory, TMenuItem } from "../types"
import parsePrice from "../utils/parsePrice"
import ItemComponentsByCategory from "./ItemComponentsByCategory"
import PriceRender from "./PriceRender"
import StyledButton from "./StyledButton"
import StyledPaper from "./StyledPaper"
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import lodash from 'lodash';

const ComponentSelector: React.FC<{ item: TMenuItem, onFinishSelection: (item: TMenuItem) => void }> = (props) => {
    const { item, onFinishSelection } = props
    const [quantity, setQuantity] = useState(1)
    const [itemDraft, setItemDraft] = useState(item)

    const requiredComponents = useMemo(() => itemDraft.components.filter(component => component.isBase || component.isRequired), [itemDraft])
    const isItemComplete = requiredComponents.reduce<Boolean>(
        (acc, component) => acc && Boolean(component.options.find(option => option.value > 0)), true
    )

    const onComponentChange = (newComponent: TComponentCategory) => {
        const newDraft = lodash.cloneDeep(itemDraft)
        const componentIndex = itemDraft.components.findIndex(component => component.name === newComponent.name)
        newDraft.components.splice(componentIndex, 1, newComponent)
        setItemDraft(newDraft)
    }

    return <Box sx={{ p: '12px 24px 24px 12px', height: 'calc(100vh - 112px)' }}>
        <Box>
            <Box display={'flex'} justifyContent={'center'} mb={'24px'} overflow={'hidden'}>
                <Box
                    display={'flex'}
                    justifyContent={'center'}
                    width={'454px'}
                    height={'454px'}
                    sx={{
                        border: '1px solid #fafafa',
                        borderRadius: '50%',
                        boxShadow: '0px -6px 4px 0px #A5A5BA12 inset',
                        marginTop: '-227px'
                    }}>
                    <Box
                        display={'flex'}
                        justifyContent={'center'}
                        width={'280px'}
                        height={'280px'}
                        sx={{
                            border: '1px solid #fafafa',
                            borderRadius: '50%',
                            boxShadow: '0px -6px 4px 0px #A5A5BA12 inset',
                            marginTop: '140px'

                        }}>
                        <Avatar
                            sx={{ width: '170px', height: '170px', marginTop: '87px' }}
                            src={itemDraft?.imagePath && getFixedImageUrl(itemDraft.imagePath)}
                            alt={`${itemDraft.name} image`}
                        />
                    </Box>
                </Box>
            </Box>
            <Box display={'flex'} justifyContent={'space-between'} mb={'12px'}>
                <Typography fontSize={'20px'} fontWeight={700}>{itemDraft.name}</Typography>
                <PriceRender price={parsePrice(itemDraft)} color='#FF7B2C' />
            </Box>
            <Box mb={'24px'}>
                <Typography>{itemDraft.productDescription}</Typography>
            </Box>
        </Box>
        <ItemComponentsByCategory componentsCategories={itemDraft.components} onComponentChange={onComponentChange} />
        <StyledPaper
            sx={{
                position: 'sticky',
                bottom: '0',
                height: '54px',
                padding: '16px',
                display: 'flex',
                margin: '0 -24px',
                justifyContent: 'space-between'
            }}
        >
            <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} alignItems={'center'}
                sx={{ background: '#F6F6F9', borderRadius: '16px', padding: '16px 20px' }}>
                <IconButton
                    onClick={() => setQuantity(quantity - 1)}
                    size='small'
                    sx={{ height: '32px', width: '32px', color: '#8E8EA9', backgroundColor: '#F6F6F9' }}
                >
                    <RemoveOutlinedIcon />
                </IconButton>
                <Box px='16px' justifyContent={'center'} flex='1' alignItems={'center'}>
                    <Typography variant='body2' sx={{ lineHeight: '10px' }}>{quantity}</Typography>
                </Box>
                <IconButton
                    onClick={() => setQuantity(quantity + 1)}
                    size='small'
                    sx={{ height: '32px', width: '32px', color: '#8E8EA9', backgroundColor: '#F6F6F9' }}
                >
                    <AddOutlinedIcon />
                </IconButton>
            </Box>
            <StyledButton variant='contained' disabled={!isItemComplete}
                onClick={() => {
                    const newDraft = lodash.cloneDeep(itemDraft)
                    newDraft.orderCount = quantity
                    onFinishSelection(newDraft)
                }}>
                <Typography mr={'8px'}>{t`Add to order`}</Typography>
                <PriceRender price={(parsePrice(itemDraft) * quantity)} />
            </StyledButton>
        </StyledPaper>
    </Box>
}

export default ComponentSelector;